import { useEffect, useState } from 'react';
import { Image, Flex, Space, Loader } from '@mantine/core';
import { AuthWrapper } from 'src/components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import { AuthFormHoc } from 'src/hoc';
import EmailConfirmImage from 'src/assets/images/email-confirm.png';
import { useAlert } from '@common/hooks';
import { useDocumentTitle } from '@mantine/hooks';
import { Button } from '@common/components';
import { PATHS } from 'src/constants';

const SigUpVerifyPage = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [t] = useTranslation('auth');
  const [c] = useTranslation('common');
  const urlParams = new URLSearchParams(location.search);
  const email: string = urlParams.get('email') as string;
  const code: string = urlParams.get('code') as string;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorConfirm, setErrorConfirm] = useState<string | null>(null);

  useDocumentTitle(t('signUpVerifyPageTitle'));

  useEffect(() => {
    const signUpConfirmResponse = async (): Promise<void> => {
      setIsLoading(true);
      try {
        await Auth.confirmSignUp(email, code);
      } catch (error) {
        if (error instanceof Error) {
          showAlert({
            id: error.message,
            title: c('Error'),
            message: error.message,
            variant: 'error',
          });
          setErrorConfirm(error.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    signUpConfirmResponse();
  }, []);

  const navaigateToLogin = (): void => {
    navigate(PATHS.LOGIN, {
      state: {
        firstLogin: true,
      },
    });
  };

  return (
    <AuthWrapper
      leftColumn={
        <Image style={{'filter': 'invert(20%) sepia(75%) saturate(5000%) hue-rotate(240deg)'}} maw={400} mx={'auto'} radius={'md'} src={EmailConfirmImage} alt={`${t('introductionImageLabel')}`} /> 
      }
      rightColumn={
        <Flex direction={{ base: 'column' }}>
          {isLoading ? (
            <Loader color={'#5b5eff'} />
          ) : (
            <>
              <AuthFormHoc
                title={errorConfirm ? t('errorConfirmTitle') : t('confirmSuccess')}
                description={
                  <div>
                    <p>{errorConfirm ? (errorConfirm as string) : ''}</p>
                    <Space h={'md'} />
                    {!errorConfirm && (
                      <Button onClick={navaigateToLogin} fullWidth>
                        {t('login')}
                      </Button>
                    )}
                  </div>
                }
              />
            </>
          )}
        </Flex>
      }
    />
  );
};

export default SigUpVerifyPage;
